import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LibraryBigIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-slate-950 py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-125" data-mp="1iw32ha07833a">
      <div className="mx-auto max-w-6xl px-4" data-id="element-126" data-mp="1dxt7azeh52ho">
        <div className="text-center" data-id="element-127" data-mp="2bk8p62atc25r">
          <span className="inline-flex items-center gap-2 rounded-full border border-slate-400/30 bg-slate-800 px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-slate-200" data-id="element-128" data-mp="2bj7dbvlz3bmz">
            <LibraryBigIcon className="h-4 w-4" aria-hidden="true" data-id="element-129" data-mp="21ljfuxwzfq14" /> Complete classroom coverage
          </span>
          <h2 id="modules-title" className="mt-4 text-3xl font-extrabold text-white sm:text-4xl" data-id="element-130" data-mp="1wly75vs0g3b7">
            The {totalVolumes} comprehensive volumes
          </h2>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-131" data-mp="l7b8iaks9na2">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.3,
            delay: index % 2 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col overflow-hidden rounded-xl border border-slate-400/20 bg-slate-900 shadow-lg shadow-black/20" data-id="element-132" data-mp="1it5vkyjbn9sd" data-mpi={index}>
                <div className="flex items-center gap-4 border-b border-slate-400/20 bg-slate-700 px-6 py-5" data-id="element-133" data-mp="14x0nh7bpbvkc">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg metal text-slate-950" data-id="element-134" data-mp="q8eahc9jrfwa">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-135" data-mp="v3be23o24x1s" />
                  </span>
                  <div data-id="element-136" data-mp="h7zjpxdtd8le">
                    <p className="text-xs font-bold uppercase tracking-[.14em] text-slate-200" data-id="element-137" data-mp="l78e94gohai0">Volume {module.number}</p>
                    <h3 className="mt-1 text-lg font-bold leading-tight text-white" data-id="element-138" data-mp="2nuf1lvs8w85s">{module.title}</h3>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-6" data-id="element-139" data-mp="2j1c9ls3496rp">
                  <p className="font-semibold text-white" data-id="element-140" data-mp="2e5doqegzy6w1">{module.subtitle}</p>

                  <p className="mt-5 text-xs font-bold uppercase tracking-[.12em] text-slate-400" data-id="element-141" data-mp="295rac1pfmkln">
                    What does it solve in the classroom?
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-slate-300" data-id="element-142" data-mp="31twvgpkeebm0">{module.context}</p>

                  <ul className="mt-5 grid flex-1 content-start gap-2" data-id="element-143" data-mp="2wutp91solzcg">
                    {module.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-slate-100" data-id="element-144" data-mp="2strt4tu2a3ep">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-slate-300" aria-hidden="true" data-id="element-145" data-mp="1lfx0lt0etc5m" />
                        {item}
                      </li>)}
                  </ul>

                  <p className="mt-6 rounded-lg border-l-4 border-slate-300 bg-slate-800 p-4 text-sm leading-relaxed text-slate-100" data-id="element-146" data-mp="3t2gaf3yxrevg">
                    <b className="font-extrabold text-white" data-id="element-147" data-mp="xvwisyf88uu">Result: </b>
                    {module.result}
                  </p>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-xl metal px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-148" data-mp="apa65tk36p1p">
          <p className="text-xs font-bold uppercase tracking-[.16em] text-slate-700" data-id="element-149" data-mp="kkk68bqxcmcu">Main collection</p>
          <p className="text-2xl font-extrabold text-slate-950 sm:text-3xl" data-id="element-150" data-mp="oo9oykkx49py">
            {totalVolumes} premium volumes <span className="mx-2 text-slate-500" data-id="element-151" data-mp="tl03v4kzkz9s">·</span> Updated for 2026
          </p>
        </div>
      </div>
    </section>;
}